<template>
  <div>
    <timeline-conflict-modal
      @reserveAnyway="confirmMeetingAnywayHandler"
      :calendar="calendarType"
      isMeetingConfirmation
    />
    <div class="confirmation-wrapper">
      <div class="flex flex-wrap items-center justify-center gap-x-102">
        <p class="font-bold">{{ $t('going') }}</p>
        <div class="flex justify-center flex-wrap">
          <input
            class="confirmation-input confirm-accept"
            type="radio"
            value="yes"
            v-model="confirmStatus"
            @change="openRecurringModal()"
            name="confirmInputs"
            id="accept"
          />
          <label for="accept"> {{ $t('yes') }} </label>
          <input
            class="confirmation-input confirm-maybe"
            type="radio"
            value="maybe"
            v-model="confirmStatus"
            @change="openRecurringModal()"
            name="confirmInputs"
            id="maybe"
          />
          <label for="maybe"> {{ $t('maybe') }} </label>
          <input
            class="confirmation-input confirm-deny"
            type="radio"
            value="no"
            v-model="confirmStatus"
            @change="openRecurringModal()"
            name="confirmInputs"
            id="deny"
          />
          <label for="deny"> {{ $t('no') }} </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axiosConfig from '@/services/axios.config';
import serverErrorsHandler from '@/utils/serverErrorsHandler';
import TimelineConflictModal from '@/components/modals/TimelineConflictModal.vue';

export default {
  name: 'ConfirmMeeting',
  components: {
    TimelineConflictModal,
  },
  props: {
    currentUserStatus: {
      type: String,
      default: '',
    },
    isMeetingRepetitive: {
      type: Boolean,
      default: false,
    },
    meetingInfo: {
      type: Object,
    },
  },
  data() {
    return {
      confirmStatus: '',
      previousStatus: '',
      confirmWithConflict: 0,
      calendarType: '',
      meetingInfoID: this.$route.params.reserveId,
      companyId: this.$route.params.companyId,
      deviceId: this.$route.params.deviceId,
      meetingRepeatType: '',
    };
  },
  watch: {
    currentUserStatus(status) {
      this.confirmStatus = status;
    },
    confirmStatus(newVal, oldVal) {
      this.previousStatus = oldVal;
    },
  },
  mounted() {
    this.confirmStatus = this.currentUserStatus;
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    recurringConfirmationHandler(data) {
      this.meetingRepeatType = data;
      this.meetingConfirmationHandler();
    },
    openRecurringModal() {
      if (this.isMeetingRepetitive) {
        this.$store.dispatch('modal/open', 'editRecurringConfirmation');
      } else {
        this.meetingConfirmationHandler();
      }
    },
    closeModals(...modals) {
      modals.map((modalName) => this.$store.dispatch('modal/close', modalName));
    },
    meetingConfirmationHandler() {
      const STATUS = {
        status: this.confirmStatus,
        without_conflict: this.confirmWithConflict,
        repeat: {},
        t: this.$route.query.t || '',
      };
      STATUS.repeat.confirm = this.meetingRepeatType;
      axiosConfig
        .post(
          `/companies/${this.companyId || this.meetingInfo.company_id}/reservations/${this.meetingInfoID || this.meetingInfo.id}/confirm`,
          STATUS,
        )
        .then(() => {
          this.$emit('RefreshMeeting');
          this.confirmWithConflict = 0;
          this.closeModals('editRecurringConfirmation');
        })
        .catch((error) => {
          const { response } = error;
          if (error.response.status === 410) {
            this.$store.commit('reserve/SET_CONFLICT', response.data.data);
            this.$store.dispatch('modal/open', 'conflict');
            this.confirmStatus = this.previousStatus;
          }
          serverErrorsHandler(error);
          throw error;
        });
    },
    confirmMeetingAnywayHandler() {
      this.confirmWithConflict = 1;
      this.confirmStatus = this.previousStatus;
      this.meetingConfirmationHandler();
    },
  },
};
</script>
<style>
.confirmation-wrapper {
  @apply flex sticky right-0 bottom-0 justify-center
   items-center bg-transparent bg-opacity-20 rounded-sm
  py-28 w-full;
  backdrop-filter:blur(42px);
}
</style>
<style lang="css" scoped>
.confirmation-input:checked + label,
.confirmation-input:not(:checked) + label {
  @apply inline-block rounded relative text-title font-bold text-sm
  px-30 py-10 mx-5 text-center overflow-hidden cursor-pointer;
  -webkit-transition: all 300ms linear;
  transition: all 300ms linear;
}
.confirmation-input:not(:checked) + label {
  @apply bg-primary border border-default text-title;
}
.confirm-accept:checked + label {
  @apply bg-successOpacity text-success border border-success;
}
.confirm-deny:checked + label {
  @apply bg-dangerOpacity  text-danger border border-danger;
}
.confirm-maybe:checked + label {
  @apply bg-primaryOpacity text-info border border-info;
}
[type='radio']:checked,
[type='radio']:not(:checked) {
  position: absolute;
  left: 0;
  width: 0;
  height: 0;
  visibility: hidden;
}
</style>
